// extracted by mini-css-extract-plugin
export default {"title":"title-s0lJC","body":"body-KQrfZ","dropdown":"dropdown-pZfII","createButton":"createButton-DUwfq","disabled":"disabled-ACxY7"};